<template>
    <div class="bg-sky-800 text-sky-50 w-dvw h-dvh flex flex-col items-center px-6 overflow-y-auto">
        <div class="flex-1" />
        <div
            class="shadow-[0_0_0.125rem_1rem] shadow-sky-900/70 max-w-220 w-full shrink-0 my-6 bg-sky-50 text-gray-700 rounded-lg grid grid-cols-1 lg:grid-cols-[2fr_1px_3fr] gap-y-10 lg:gap-y-6 p-6 lg:p-10 lg:gap-x-10"
        >
            <div class="flex min-w-0 justify-center lg:justify-normal">
                <slot name="inner-container-left" />
            </div>

            <div class="w-px h-full bg-gray-200 hidden lg:block" />

            <div class="flex min-w-0">
                <slot name="inner-container-right" />
            </div>

            <div class="lg:col-span-3">
                <slot name="inner-container-bottom" />
            </div>
        </div>

        <div class="flex-1 flex flex-col justify-end items-start pb-4 self-stretch">
            <slot name="version-indicator" />
        </div>
    </div>
</template>
